export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PARAM_TYPES = [
  { value: 'taxe', label: 'Taxe', icon: '💰', color: 'red' },
  { value: 'contribution', label: 'Contribution', icon: '🏛️', color: 'blue' },
  { value: 'frais', label: 'Frais', icon: '📋', color: 'orange' },
  { value: 'commission', label: 'Commission', icon: '🤝', color: 'green' },
  { value: 'majoration', label: 'Majoration', icon: '📈', color: 'purple' },
  { value: 'reduction', label: 'Réduction', icon: '📉', color: 'teal' },
  { value: 'divers', label: 'Divers', icon: '⚙️', color: 'gray' }
];

export const PARAM_COLOR_BADGES = {
  red: 'bg-red-700 text-white',
  blue: 'bg-blue-700 text-white',
  orange: 'bg-orange-700 text-white',
  green: 'bg-green-700 text-white',
  purple: 'bg-purple-700 text-white',
  teal: 'bg-teal-700 text-white',
  gray: 'bg-gray-700 text-white'
};

export const CALC_MODES = [
  { value: 'pourcentage', label: 'Pourcentage (%)' },
  { value: 'fixe', label: 'Montant fixe (€)' },
  { value: 'coefficient', label: 'Coefficient multiplicateur' }
];

export const AJUSTEMENT_TYPES = [
  { value: 'remplacement', label: 'Remplacement', icon: '🔄', description: 'Remplacer les montants calculés par des valeurs fixes' },
  { value: 'pourcentage', label: 'Pourcentage', icon: '📊', description: 'Ajuster les montants par un pourcentage' },
  { value: 'fixe', label: 'Montant fixe', icon: '💰', description: 'Ajouter/soustraire un montant fixe' }
];

export const AJUSTEMENT_CIBLES = [
  { value: 'tous', label: 'Tous les montants' },
  { value: 'prime_ht', label: 'Prime (Montant de base) uniquement' },
  { value: 'prime_ttc', label: 'Prime TTC uniquement' },
  { value: 'ca_base', label: "Chiffre d'affaires de base" }
];

export const RESTRICTION_TYPES = [
  { value: 'territoire', label: 'Par territoire', icon: '🗺️', description: 'Limiter à certains territoires' },
  { value: 'activite', label: "Par type d'activité", icon: '🏗️', description: 'Limiter à certaines activités' },
  { value: 'seuil_ca', label: 'Par seuil CA', icon: '💰', description: 'CA minimum ou maximum' },
  { value: 'experience', label: "Par années d'expérience", icon: '📅', description: 'Ancienneté minimum' },
  { value: 'effectif', label: 'Par effectif', icon: '👥', description: 'Nombre de salariés' },
  { value: 'nb_activites', label: "Par nombre d'activités", icon: '📊', description: "Nombre d'activités max" },
  { value: 'categorie', label: 'Par catégorie', icon: '📁', description: "Catégorie d'activité" },
  { value: 'statut_juridique', label: 'Par statut juridique', icon: '⚖️', description: 'Type de structure' },
  { value: 'date', label: 'Par période', icon: '📆', description: 'Période de validité' },
  { value: 'combinee', label: 'Combinée', icon: '🔗', description: 'Plusieurs conditions' }
];

export const RESTRICTION_ACTIONS = [
  { value: 'bloquer', label: 'Bloquer', color: 'red' },
  { value: 'avertir', label: 'Avertir', color: 'amber' },
  { value: 'majorer', label: 'Majorer tarif', color: 'orange' },
  { value: 'minorer', label: 'Minorer tarif', color: 'green' },
  { value: 'rediriger', label: 'Rediriger', color: 'blue' }
];

export const ACTION_COLOR_BADGES = {
  red: 'bg-red-700 text-white border-red-800',
  amber: 'bg-amber-700 text-white border-amber-800',
  orange: 'bg-orange-700 text-white border-orange-800',
  green: 'bg-green-700 text-white border-green-800',
  blue: 'bg-blue-700 text-white border-blue-800'
};

export const COEF_COLOR_CLASSES = {
  blue: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700' },
  green: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700' },
  purple: { bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-700' },
  amber: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700' }
};
